import { render, staticRenderFns } from "./DocumentArchiveButton.vue?vue&type=template&id=25636504&scoped=true&"
import script from "./DocumentArchiveButton.vue?vue&type=script&lang=ts&"
export * from "./DocumentArchiveButton.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentArchiveButton.vue?vue&type=style&index=0&id=25636504&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25636504",
  null
  
)

export default component.exports